import angular from "angular";
import StaffSignupController from "./staff-signup.controller";
import template from "./staff-signup.html";
import "../../../assets/images/logo-for-wht-bg.svg";
function config($stateProvider, $urlRouterProvider) {
  $stateProvider.state("drivecoach.signup.staff", {
    url: "/staff",
    controller: StaffSignupController,
    controllerAs: "vm",
    template: template,
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];

export default angular
  .module("signup.staff", [])
  .config(config)
  .controller("StaffSignupController", StaffSignupController);
